import {useMediaQuery} from "@mui/material";

const useMobile = (): boolean => {
  return useMediaQuery("(max-width:600px)");
};

export default useMobile;
